module.exports = __webpack_public_path__ + "img/98ne.b9b3505b.svg";